module.exports = __webpack_public_path__ + "img/tertiary_8x2_z16.61ad7e69.svg";